import React from 'react';
import leadMockUpdates from '../../data/leadStatusMockUpdates.json'
import CommentCompactView from "./CommentCompactView";
import mockAgentData from '../../data/agentCriteriaMockData.json'
import AgentMatchCriteriaView from "./AgentMatchCriteriaView";
import LeadStatusUpdatePage from "./LeadStatusUpdatePage";

function AgentHome() {
    const items = leadMockUpdates.updates.map(item => <CommentCompactView key={item.id} data={item}/>)
    const agentCriteria = mockAgentData.criteriaList.map(item => <AgentMatchCriteriaView key={item.id} data={item}/>)
    return (
        <div>
            <div>

                <div style={{margin: 20}}>
                    <LeadStatusUpdatePage agentId="1000" leadAgentId="1"/>
                </div>

                {/* <div style={{margin: 20 }}>*/}
                {/*     <LeadContactInfo />*/}
                {/* </div>*/}

                {/* <div style={{margin: 20 }}>*/}
                {/*     <LeadPropertyDetailsView data={mockLeadInfo.leadInformation.propertyCharacteristics} />*/}
                {/* </div>*/}

                {/* <div style={{margin: 20 }}>*/}
                {/*     <LeadStatusUpdate />*/}
                {/* </div>*/}

                {/*<div style={{margin: 20 }}>*/}
                {/*    {*/}
                {/*        items*/}
                {/*    }*/}
                {/*</div>*/}
                {/*               <div style={{margin: 20 }}>
                    {
                        agentCriteria
                    }
                </div>

               <div style={{marginBottom: 150}}> &nbsp;</div>
                <LinkContainer to="/agent-leads">
                    <Button variant="contained" color="primary">
                        Agent Leads
                    </Button>
                </LinkContainer>
*/}
            </div>
        </div>
    )

}

export default AgentHome;
